module.exports = __webpack_public_path__ + "static/media/rectangle-portrait.b47f1b12.svg";